"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*exported AnD_651 */

var AnD_651_reader = function (_AnD_Ble_reader) {
  _inherits(AnD_651_reader, _AnD_Ble_reader);

  function AnD_651_reader() {
    _classCallCheck(this, AnD_651_reader);

    return _possibleConstructorReturn(this, (AnD_651_reader.__proto__ || Object.getPrototypeOf(AnD_651_reader)).apply(this, arguments));
  }

  _createClass(AnD_651_reader, [{
    key: "onConnect",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
        var settings;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.readBufferSettings();

              case 2:
                settings = _context.sent;
                _context.next = 5;
                return this.setClock(new Date());

              case 5:
                _context.next = 7;
                return this.setNumberOfMeasurements(0);

              case 7:
                _context.next = 9;
                return this.getBatteryStatus();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onConnect(_x) {
        return _ref.apply(this, arguments);
      }

      return onConnect;
    }()
  }]);

  return AnD_651_reader;
}(AnD_Ble_reader);

var AnD_651 = new JS.Class(BLE_Device, {
  initialize: function initialize(device_uuid) {
    var name = "A&D Medical 651BLE";
    var model_name = "UA-651BLE";

    return this.callSuper(name, model_name, device_uuid, '1810', ['2A35']);
  },

  getAdvertisedName: function getAdvertisedName() {
    return "A&D_UA-651BLE_" + this.ble_id.replace(/\:/g, "").slice(-6).toUpperCase();
  },

  needsPairing: function needsPairing() {
    return true;
  },

  makeReader: function makeReader() {
    return new AnD_651_reader(this);
  },

  _decode_result: function _decode_result(result, reader) {
    // [ 22, 134, 0, 71, 0, 111, 0, 208, 7, 2, 13, 13, 23, 52, 55, 0, 0, 0 ]

    var result_byte_array = new Uint8Array(result);

    var status = this._decode_status_byte(result_byte_array[17]);
    var hr = result_byte_array[14];

    var year = result_byte_array[7] + (result_byte_array[8] << 8 & 0xFF00);
    var month = result_byte_array[9] - 1;
    var day = result_byte_array[10];
    var hour = result_byte_array[11];
    var minute = result_byte_array[12];
    var second = result_byte_array[13];

    var date = new Date(year, month, day, hour, minute, second);

    //Date has not been set
    if (result_byte_array.length == 11) {
      status = this._decode_status_byte(result_byte_array[9]);
      hr = result_byte_array[7];
      date = new Date();
    }
    var flags = this._decode_flags_byte(result_byte_array[0]);

    var sbp, dbp, map;

    if (flags.unit == "mmHg") {
      sbp = result_byte_array[1];
      dbp = result_byte_array[3];
      map = result_byte_array[5];
    } else {
      sbp = kanayo.util.Ieee11073ToDecimal(result_byte_array[1], result_byte_array[2]);
      dbp = kanayo.util.Ieee11073ToDecimal(result_byte_array[3], result_byte_array[4]);
      map = kanayo.util.Ieee11073ToDecimal(result_byte_array[5], result_byte_array[6]);
    }

    var designations = [];

    if (status.irregular_pulse) {
      designations.push('irreg_pulse_detected');
    }

    return {
      valid: true,
      status: status,
      batteryStatus: this.batteryStatus,
      date: date,
      readings: [{ main: true,
        measurements: [{ name: "sbp", value: "" + sbp, unit: flags.unit, designations: [] }, { name: "dbp", value: "" + dbp, unit: flags.unit, designations: [] }, { name: "hr", value: "" + hr, unit: 'bpm', designations: designations }, { name: "map", value: "" + map, unit: flags.unit, designations: [] }]
      }]
    };
  },

  _decode_flags_byte: function _decode_flags_byte(flags) {

    return {
      unit: (flags & 0x01) == 0x01 ? 'kPa' : 'mmHg',
      time_stamp: (flags & 0x02) == 0x02 ? true : false,
      pulse_rate: (flags & 0x04) == 0x04 ? true : false,
      user_id: (flags & 0x08) == 0x08 ? true : false,
      bp: (flags & 0x10) == 0x10 ? true : false
    };
  },

  _decode_status_byte: function _decode_status_byte(statusByte) {

    var status = {};

    status.body_movement = (statusByte & 0x01) == 0x01 ? true : false;
    status.loose_cuff = (statusByte & 0x02) == 0x02 ? true : false;
    status.irregular_pulse = (statusByte & 0x04) == 0x04 ? true : false;

    var range = (statusByte & 0x10 == 0x10 ? "1" : "0") + (statusByte & 0x08 == 0x08 ? "1" : "0");
    status.rate_range = 'normal';
    if (range == "10") {
      status.rate_range = 'fast';
    } else if (range == "01") {
      status.rate_range = 'slow';
    }

    status.body_movement = (statusByte & 0x20) == 0x20 ? true : false;

    return status;
  }
});